import { gql } from '@apollo/client'

export const FRAGMENT_WORKSPACE_BRAND = gql`
  fragment FragmentWorkspaceBrand on WorkspaceBrand {
    id
  }
`
